var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow" }, [
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: _vm.required, url: { require_tld: true } },
              expression: "{ required: required, url: { require_tld: true } }",
            },
          ],
          attrs: {
            id: "url",
            type: "text",
            name: "url",
            placeholder: _vm.placeholder,
          },
          domProps: { value: _vm.value },
          on: { input: _vm.adjustUrl },
        }),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "inline-flex px-2 text-black underline text-black",
          attrs: { href: `https://${_vm.value}`, target: "_blank" },
        },
        [
          _c("span", { staticClass: "self-center uppercase" }, [
            _vm._v("Test Link"),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("url"),
            expression: "errors.has('url')",
          },
        ],
        staticClass: "text-lg error text-error-red",
      },
      [_vm._v("\n    " + _vm._s(_vm.errors.first("url")) + "\n  ")]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "inline-flex flex-initial px-4 border-t border-b border-l border-gray-medium bg-gray-hr rounded-l",
      },
      [_c("span", { staticClass: "self-center" }, [_vm._v("http(s)://")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }